module.exports = __webpack_public_path__ + "static/media/Inter-Medium.11cec23a.woff";